import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function SmoothScroll() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf = requestAnimationFrame(function loop(t) {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        });
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="min-h-screen bg-paper text-ink flex flex-col items-center justify-center gap-4 p-8">
                    <p className="font-display text-3xl font-extrabold uppercase">Something broke</p>
                    <p className="text-inkdim text-sm">{String(this.state.error)}</p>
                    <a href="/" className="underline text-sm">Reload the site</a>
                </div>
            );
        }
        return this.props.children;
    }
}

export default function App() {
    return (
        <ErrorBoundary>
            <AuthProvider>
                <BrowserRouter>
                    <SmoothScroll />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <div className="grain-overlay" aria-hidden="true" />
                <Toaster richColors position="bottom-right" />
            </AuthProvider>
        </ErrorBoundary>
    );
}
